import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { getFormAccessToken } from "../_helpers/formAccessToken.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "quoteProviderPrice";

export const quoteProviderPriceService = {
    updateOnApply,
    updateOnApplyForMortgage
};

function updateOnApply(query: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(query) };
    const accessToken = getFormAccessToken(query?.formId);
    let url = `${API_URL}/${API_NAME}/updateOnApply/`;
    if (accessToken) {
        url += `?token=${encodeURIComponent(accessToken)}`;
    }
    return fetch(url, requestOptions).then(handleResponse);
}
function updateOnApplyForMortgage(id: number, quoteId: number, formId?: number | string) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    const accessToken = getFormAccessToken(formId);
    let url = `${API_URL}/${API_NAME}/updateOnApplyForMortgage/?id=${id}&quoteId=${quoteId}`;
    if (accessToken) {
        url += `&token=${encodeURIComponent(accessToken)}`;
    }
    return fetch(url, requestOptions).then(handleResponse);
}

